<template>
  <div>
    <div class="v2-projects__bg v2-projects__bg--1"> </div>
    <div class="v2-projects__bg v2-projects__bg--2"> </div>
    <div class="v2-projects__bg v2-projects__bg--3"> </div>
    <div class="v2-projects__bg v2-projects__bg--4"> </div>
    <div class="v2-projects__bg v2-projects__bg--5"> </div>
  </div>
</template>

<script>
// see https://github.com/codrops/ImageGridMotionEffect
import Grid from "@/utils/grid.js";

import gsap from "gsap-3";

export default {
  name: "V2BgMotion",
  mounted() {
    if (window.matchMedia("(min-width: 1200px)").matches) {
      /* the viewport is at least 1200px  wide */
      // Initialize grid
      const grid = new Grid(document.querySelector(".v2-projects"));

      let $bg1 = ".v2-projects__bg--1";
      gsap
        .timeline()
        .delay(6)
        .set($bg1, {
          scale: 0,
          opacity: 0,
        })
        .to($bg1, 1, {
          opacity: 1,
          scale: 1,
          scrollTrigger: {
            trigger: "#projects",
            start: "top 90%",
            end: "top top",
            scrub: true,
          },
        });
    }
  },
};
</script>
